import React from "react";

// Externals
import cn from "classnames";

// Component styles
import classes from "./LoginHeader.module.scss";

export default function LoginHeader(props) {
  const { title, description } = props;

  return (
    <div className={classes.loginHeader}>
      <div className={cn(classes.loginTitle, "dx-theme-accent-as-text-color")}>{title}</div>
      <div>{description}</div>
    </div>
  );
}
